import React from 'react';
import { useDispatch } from 'react-redux';
import { Title } from '../setup-conference-room';
import { setCompanionMode } from '../../../stores/actions/session';
import Icon, { ICONS, COLORS } from '../../general-components/icon';
import { Button } from './elements';

export default function SuccessSplash() {
	const dispatch = useDispatch();

	return (<>
		<div className="flex-center">
			<div className="flex-column flex-center">
				<Title className='bl-font-header' style={{ marginBottom: '8px' }}>Configuration complete</Title>
				<h4 className='bl-font-header margin-none'>You may now close this tab</h4>
			</div>
			<div className="button-container position-absolute flex gap-small" style={{ bottom: '200px' }}>
				<Button
					className="link"	
					onClick={() => {
						window.open('https://support.brandlive.com/hc/en-us/articles/31259261433243-How-to-Join-Greenroom-via-Conference-Room', '_blank');
					}}
				>
					Learn More
					<Icon name={ICONS.EXPAND} size={16} color={COLORS.TEXT_GRAY_200} />
				</Button>
				<Button className="transparent success" onClick={() => dispatch(setCompanionMode(true))}>
					Companion Mode
				</Button>
			</div>
		</div>
	</>);
}
